import React from 'react';
import { func, instanceOf } from 'prop-types';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';
import DeButton from './DeButton';
import * as urls from '../../../actions/urlTypes';

const ImportActions = ({ setView, router }) => {
  const impersonated = useSelector(state => state.login.loginResponse.data.impersonated);
  const handleBuild = () => {
    sessionStorage.setItem('showDictionarySearch', true);
    router.push({
      pathname: `${urls.APP_ROOT_URL}/datahub/build`,
    });
  };
  return (
    <div className="de--createNew--actions">
      <DeButton
        label="Import"
        onClick={() => setView('importDefination')}
        outline
        fill="secondary"
        data-test="import"
        disabled={impersonated}
      />
      <DeButton
        data-test="build"
        label="Build New"
        onClick={handleBuild}
        fill="secondary"
        disabled={impersonated}
      />
    </div>
  );
};

ImportActions.propTypes = {
  setView: func,
  router: instanceOf(Object),
};

export default withRouter(ImportActions);
